import React from "react";
import { Tooltip } from "antd";

type Props = {
  isUnread?: boolean;
  color?: string; // color used when not unread (e.g. status color)
  size?: number; // pixel size of the dot
  style?: React.CSSProperties;
  title?: string;
};

const UnreadIndicator: React.FC<Props> = ({
  isUnread = false,
  color = "#1890ff",
  size = 8,
  style,
  title,
}) => {
  const background = isUnread ? "gray" : color;
  const tooltipText =
    title ?? (isUnread ? "Unread comments" : "No unread comments");

  return (
    <Tooltip title={tooltipText}>
      <div
        role="img"
        aria-label={tooltipText}
        style={{
          width: size,
          height: size,
          borderRadius: "50%",
          backgroundColor: background,
          marginLeft: 6,
          flex: "0 0 auto",
          boxShadow: isUnread ? "0 0 0 2px rgba(0,0,0,0.04) inset" : undefined,
          ...style,
        }}
      />
    </Tooltip>
  );
};

export default UnreadIndicator;
